const service = {
  path: "/service",
  name: "service",
  redirect: "/service/platform/indexChannel",
  component: () => import("@/views/service/index.vue"),
  title: "产品服务",
  children: [
    {
      path: "/service/platform",
      name: "platform",
      redirect: "/service/platform/indexChannel",
      component: {
        render: c => c("router-view")
      },
      title: "智能平台",
      children: [
        {
          path: "/service/platform/indexChannel",
          name: "indexChannel",
          component: () => import("@/views/service/platform/indexChannel.vue"),
          title: "全渠道营销平台"
        },
        {
          path: "/service/platform/indexFlowRate",
          name: "indexFlowRate",
          component: () => import("@/views/service/platform/indexFlowRate.vue"),
          title: "私域流量运营平台"
        }
      ]
    },
    {
      path: "/service/middleground",
      name: "middleground",
      redirect: "/service/middleground/indexData",
      component: {
        render: c => c("router-view")
      },
      title: "数字中台",
      children: [
        {
          path: "/service/middleground/indexData",
          name: "indexData",
          component: () => import("@/views/service/middleground/indexData.vue"),
          title: "数据中台"
        },
        {
          path: "/service/middleground/indexBusiness",
          name: "indexBusiness",
          component: () =>
            import("@/views/service/middleground/indexBusiness.vue"),
          title: "业务中台"
        }
      ]
    },
    {
      path: "/service/retail",
      name: "retail",
      redirect: "/service/retail/indexSmallRoutine",
      component: {
        render: c => c("router-view")
      },
      title: "智能零售",
      children: [
        {
          path: "/service/retail/indexSmallRoutine",
          name: "indexSmallRoutine",
          component: () =>
            import("@/views/service/retail/indexSmallRoutine.vue"),
          title: "小程序商城"
        },
        {
          path: "/service/retail/indexCloudPos",
          name: "indexCloudPos",
          component: () => import("@/views/service/retail/indexCloudPos.vue"),
          title: "云POS"
        }
      ]
    }
  ]
};

export default service;
